import { Typography } from "@faire/web/slate/Typography";

export const SettingsSectionHeaderContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
    {children}
  </div>
);

export const SettingsSectionHeader = ({
  title,
  description,
}: {
  title: string;
  description?: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col gap-2 pt-4 pb-5 md:pt-5">
      <Typography
        variant={{
          mobileAndAbove: "subheadingSansMedium",
          desktopAndAbove: "sectionHeaderSansMedium",
        }}
      >
        {title}
      </Typography>
      {description ? <Typography>{description}</Typography> : null}
    </div>
  );
};

export const SettingsSectionHeaderButtonWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="mb-6 flex w-full flex-col items-start justify-between md:mb-0 md:w-fit md:flex-row md:items-center">
    {children}
  </div>
);
